import React from "react";

function NoProjects() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      height="100%"
      data-name="Layer 1"
      viewBox="0 0 925.18 770.09"
    >
      <defs>
        <linearGradient
          id="f2b43956-505e-42fa-8271-42f9f0912862"
          x1="580.55"
          x2="580.55"
          y1="759"
          y2="113"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="gray" stopOpacity="0.25"></stop>
          <stop offset="0.54" stopColor="gray" stopOpacity="0.12"></stop>
          <stop offset="1" stopColor="gray" stopOpacity="0.1"></stop>
        </linearGradient>
        <linearGradient
          id="93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd"
          x1="345.9"
          x2="345.9"
          y1="617.2"
          y2="679.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e0e0e0"></stop>
          <stop offset="0.31" stopColor="#fccc63"></stop>
          <stop offset="0.77" stopColor="#f55f44"></stop>
        </linearGradient>
        <linearGradient
          id="f0b6c0c1-af46-47f0-89cc-f1295e85d837"
          x1="420.89"
          x2="420.89"
          y1="617.2"
          y2="679.83"
          xlinkHref="#93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd"
        ></linearGradient>
        <linearGradient
          id="835adc3d-9947-42f8-a8c1-90fc1375c35f"
          x1="467.86"
          x2="467.86"
          y1="617.2"
          y2="679.83"
          xlinkHref="#93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd"
        ></linearGradient>
        <linearGradient
          id="05d2e404-cee9-4ec4-9322-f8806c9b5d69"
          x1="543.67"
          x2="543.67"
          y1="617.2"
          y2="679.83"
          xlinkHref="#93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd"
        ></linearGradient>
        <linearGradient
          id="84020695-8aca-4fdc-a56d-10a85085e734"
          x1="580.55"
          x2="580.55"
          y1="835.05"
          y2="647.79"
          xlinkHref="#f2b43956-505e-42fa-8271-42f9f0912862"
        ></linearGradient>
        <linearGradient
          id="ee8b87cd-bc8a-4975-b833-23268ebbebf9"
          x1="272.71"
          x2="272.71"
          y1="586.52"
          y2="732.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#f2f2f2"></stop>
          <stop offset="0.31" stopColor="#e6e6e6"></stop>
          <stop offset="0.77" stopColor="#ccc"></stop>
        </linearGradient>
        <linearGradient
          id="93e0219e-fb1a-4fd7-ab06-cb9d2e8d46b6"
          x1="272.35"
          x2="272.35"
          y1="606.91"
          y2="766.41"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="eaf709e1-10fa-49af-93d3-e446f8f22d21"
          x1="596.45"
          x2="596.45"
          y1="606.91"
          y2="766.41"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="b99db109-4c8d-4947-bfd9-8341738d16d4"
          x1="592.44"
          x2="592.44"
          y1="620.75"
          y2="766.41"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="73d53186-09ce-4d56-8d1f-5ffca19f900f"
          x1="574.72"
          x2="574.72"
          y1="699.54"
          y2="831.37"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="f1bd4c24-bb4d-4277-a1fb-6bc8d7a55dfd"
          x1="482.23"
          x2="482.23"
          y1="737.41"
          y2="831.37"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="319244db-d860-4fad-863b-9a3a16f5944b"
          x1="665.03"
          x2="665.03"
          y1="751.98"
          y2="831.37"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="3a40aa9d-8c97-4785-a2ce-02f5c84266af"
          x1="802.69"
          x2="802.69"
          y1="737.41"
          y2="831.37"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="f3ea85b0-d529-430f-a5f3-7431de71f741"
          x1="358.41"
          x2="358.41"
          y1="737.41"
          y2="831.37"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="421cecf6-ea42-4f8e-95af-7dadfc0b5864"
          x1="710.43"
          x2="710.43"
          y1="616.63"
          y2="589.91"
          xlinkHref="#f2b43956-505e-42fa-8271-42f9f0912862"
        ></linearGradient>
        <linearGradient
          id="b76e450b-11c8-416c-a0eb-ba73061d2446"
          x1="710.43"
          x2="710.43"
          y1="590.89"
          y2="615.65"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="72df51fc-e37e-4ea5-a672-fa692e8e4323"
          x1="771.61"
          x2="771.61"
          y1="746.75"
          y2="717.62"
          xlinkHref="#f2b43956-505e-42fa-8271-42f9f0912862"
        ></linearGradient>
        <linearGradient
          id="7c061988-e8ee-45a9-b1b1-05af47469914"
          x1="771.61"
          x2="771.61"
          y1="718.34"
          y2="746.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#f2f2f2"></stop>
          <stop offset="0.31" stopColor="#e0e0e0"></stop>
          <stop offset="0.77" stopColor="#b3b3b3"></stop>
        </linearGradient>
        <linearGradient
          id="a0922416-7296-47ba-816d-5ff33eb958ea"
          x1="148.17"
          x2="148.17"
          y1="665.16"
          y2="633.14"
          xlinkHref="#f2b43956-505e-42fa-8271-42f9f0912862"
        ></linearGradient>
        <linearGradient
          id="63e85972-a6d1-4957-b932-816027d688a4"
          x1="148.17"
          x2="148.17"
          y1="633.86"
          y2="664.45"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="299d5e2e-be3b-4509-84b8-ec33c3786422"
          x1="853.67"
          x2="853.67"
          y1="152.79"
          y2="64.95"
          xlinkHref="#f2b43956-505e-42fa-8271-42f9f0912862"
        ></linearGradient>
        <linearGradient
          id="f866518d-8775-4843-b285-e9e24a2ef8da"
          x1="771.61"
          x2="771.61"
          y1="718.34"
          y2="746.02"
          xlinkHref="#ee8b87cd-bc8a-4975-b833-23268ebbebf9"
        ></linearGradient>
        <linearGradient
          id="20e3e192-3217-42d5-9266-898a1edf98f2"
          x1="389.67"
          x2="389.67"
          y1="446.79"
          y2="404.95"
          xlinkHref="#f2b43956-505e-42fa-8271-42f9f0912862"
        ></linearGradient>
      </defs>
      <path
        fill="url(#f2b43956-505e-42fa-8271-42f9f0912862)"
        d="M722 411.58a150.57 150.57 0 00-17-70c-5.34-10.15-10.21-16.46-14-20.33a10 10 0 00-11.4-2.25 10.28 10.28 0 00-4 2.58c-5.07 5.25-9.65 12.19-13.65 19.58a151.15 151.15 0 00-17.87 71.92v15.06h-9.66v-175c0-36.68-8.21-72.87-24.29-105-7.62-15.21-14.57-24.66-19.92-30.47a13.81 13.81 0 00-20.76 0c-7.24 7.87-13.77 18.27-19.48 29.33-16.91 32.79-25.5 70-25.5 107.77v173.37h-8.35v-15.78a151.15 151.15 0 00-17.87-71.92c-4-7.38-8.58-14.32-13.65-19.58a10 10 0 00-11.6-2.12l.35.19a10.31 10.31 0 00-3.26 2.28c-3.75 3.87-8.62 10.18-14 20.33a150.57 150.57 0 00-17 70v261.64h29.8l-3.25 21.51V759H490v-64.31l-3.25-21.51h29.37V434.91h8.35v237.2h23.8l-3.42 22.57V759h24.37v-64.31l-3.42-22.57h32.07l-3.42 22.57V759h24.37v-64.31l-3.42-22.57h19V434.91h9.66v238.63h7.83v-.36h25.89l-3.25 21.51V759h24.37v-64.31l-3.25-21.51H722z"
        opacity="0.7"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="#535461"
        d="M357.44 617.2L334.37 617.2 338.49 589.19 353.32 589.19 357.44 617.2z"
      ></path>
      <path
        d="M337.34 600.31L354.47 600.31 353.32 592.48 338.49 592.48 337.34 600.31z"
        opacity="0.1"
      ></path>
      <path
        fill="#535461"
        d="M555.2 617.2L532.13 617.2 536.25 589.19 551.08 589.19 555.2 617.2z"
      ></path>
      <path
        d="M535.1 600.31L552.23 600.31 551.08 592.48 536.25 592.48 535.1 600.31z"
        opacity="0.1"
      ></path>
      <path
        fill="#535461"
        d="M432.43 617.2L409.35 617.2 413.47 589.19 428.31 589.19 432.43 617.2z"
      ></path>
      <path
        d="M412.32 600.31L429.46 600.31 428.31 592.48 413.47 592.48 412.32 600.31z"
        opacity="0.1"
      ></path>
      <path
        fill="#535461"
        d="M479.39 617.2L456.32 617.2 460.44 589.19 475.27 589.19 479.39 617.2z"
      ></path>
      <path
        d="M459.29 600.31L476.43 600.31 475.27 592.48 460.44 592.48 459.29 600.31z"
        opacity="0.1"
      ></path>
      <path
        fill="#535461"
        d="M357.44 357.64H522.24V364.22999999999996H357.44z"
      ></path>
      <path
        fill="#e0e0e0"
        d="M685.13 318.46a9.29 9.29 0 00-13.77 0c-4.8 5.11-9.13 11.87-12.92 19.06a150.58 150.58 0 00-16.91 70v253.69h72.93V406.47a150 150 0 00-16.11-68.21c-5.06-9.88-9.67-16.03-13.22-19.8zM476 318.46a9.29 9.29 0 0113.77 0c4.8 5.11 9.13 11.87 12.92 19.06a150.58 150.58 0 0116.91 70v253.69h-72.95V406.47a150 150 0 0116.11-68.21c5.05-9.88 9.66-16.03 13.24-19.8z"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="#535461"
        d="M309.65 346.93L326.95 347.01 326.95 368.35 309.65 368.35 309.65 346.93z"
      ></path>
      <path
        fill="#535461"
        d="M364.86 346.93L382.16 347.01 382.16 368.35 364.86 368.35 364.86 346.93z"
      ></path>
      <path
        fill="#535461"
        d="M504.11 346.93L521.42 347.01 521.42 368.35 504.11 368.35 504.11 346.93z"
      ></path>
      <path
        fill="#535461"
        d="M559.32 346.93L576.63 347.01 576.63 368.35 559.32 368.35 559.32 346.93z"
      ></path>
      <path
        d="M502.66 337.19c-3.78-7.19-8.12-13.95-12.92-19.06a9.26 9.26 0 00-11-2.07 9.83 9.83 0 012.78 2.07c4.8 5.11 9.13 11.87 12.92 19.06a150.58 150.58 0 0116.91 70v253.67h8.24V407.22a150.58 150.58 0 00-16.93-70.03zM665 337.89c3.78-7.19 8.12-13.95 12.92-19.06a9.8 9.8 0 013.19-2.28 9.27 9.27 0 00-10.6 2.28c-4.8 5.11-9.13 11.87-12.92 19.06a150.58 150.58 0 00-16.91 70v253.67h7.42V407.93a150.58 150.58 0 0116.9-70.04z"
        opacity="0.1"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="url(#93f39c8e-311a-4ffb-9b96-ec7d8ca6b5cd)"
        d="M334.37 617.2H357.44V679.82H334.37z"
      ></path>
      <path
        fill="url(#f0b6c0c1-af46-47f0-89cc-f1295e85d837)"
        d="M409.35 617.2H432.42V679.82H409.35z"
      ></path>
      <path
        fill="url(#835adc3d-9947-42f8-a8c1-90fc1375c35f)"
        d="M456.32 617.2H479.39V679.82H456.32z"
      ></path>
      <path
        fill="url(#05d2e404-cee9-4ec4-9322-f8806c9b5d69)"
        d="M532.13 617.2H555.2V679.82H532.13z"
      ></path>
      <path
        fill="#eee"
        d="M589.7 119.56a12.84 12.84 0 00-19.65 0c-6.85 7.66-13 17.79-18.44 28.57-16 31.94-24.14 68.19-24.14 104.95v407.09h104.09V251.44c0-35.72-7.77-71-23-102.21-7.21-14.81-13.79-24.01-18.86-29.67z"
        transform="translate(-137.41 -64.95)"
      ></path>
      <rect
        width="54.31"
        height="24.89"
        x="414.23"
        y="99.83"
        fill="#0a80ff"
        rx="11"
        ry="11"
      ></rect>
      <path
        fill="url(#84020695-8aca-4fdc-a56d-10a85085e734)"
        d="M822 737.93A83 83 0 00657.12 752v1.22a76.61 76.61 0 00-9.1 1.95 75.84 75.84 0 00-142.6-12.91 75 75 0 00-20.92-4.78 82.38 82.38 0 00-5.71-18.85 75.8 75.8 0 00-151.12-2 82.45 82.45 0 00-7.42 26.37 75.88 75.88 0 00-43.49 92h607.58A75.86 75.86 0 00822 737.93z"
        opacity="0.7"
        transform="translate(-137.41 -64.95)"
      ></path>
      <circle
        cx="272.71"
        cy="659.35"
        r="72.83"
        fill="url(#ee8b87cd-bc8a-4975-b833-23268ebbebf9)"
      ></circle>
      <circle
        cx="272.35"
        cy="686.66"
        r="79.75"
        fill="url(#93e0219e-fb1a-4fd7-ab06-cb9d2e8d46b6)"
      ></circle>
      <circle
        cx="596.45"
        cy="686.66"
        r="79.75"
        fill="url(#eaf709e1-10fa-49af-93d3-e446f8f22d21)"
      ></circle>
      <circle
        cx="592.44"
        cy="693.58"
        r="72.83"
        fill="url(#b99db109-4c8d-4947-bfd9-8341738d16d4)"
      ></circle>
      <path
        fill="url(#73d53186-09ce-4d56-8d1f-5ffca19f900f)"
        d="M647.55 772.37a72.7 72.7 0 01-30.12 59H532a72.86 72.86 0 11115.54-59z"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="url(#f1bd4c24-bb4d-4277-a1fb-6bc8d7a55dfd)"
        d="M555.06 810.24a72.5 72.5 0 01-3.12 21.12H412.51v-.05a72.83 72.83 0 0169.28-93.9h.45q3.06 0 6.07.25a72.07 72.07 0 0120.09 4.59 72.85 72.85 0 0146.66 67.99z"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="url(#319244db-d860-4fad-863b-9a3a16f5944b)"
        d="M737.87 824.81q0 3.27-.29 6.47a.18.18 0 010 .09H592.5c-.2-2.16-.3-4.35-.3-6.55a72.76 72.76 0 0161.92-72A73.77 73.77 0 01665 752c1.86 0 3.71.07 5.54.2a72.89 72.89 0 0160.9 42.74c.3.66.59 1.33.86 2a72.48 72.48 0 015.57 27.87z"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="url(#3a40aa9d-8c97-4785-a2ce-02f5c84266af)"
        d="M875.52 810.24a72.5 72.5 0 01-3.12 21.12H733a73.29 73.29 0 01-1.87-34.54c.12-.63.24-1.27.38-1.89a72.86 72.86 0 0171.22-57.51c2.29 0 4.54.1 6.77.32 1 .08 2 .2 3 .33a72.84 72.84 0 0163.02 72.17z"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="url(#f3ea85b0-d529-430f-a5f3-7431de71f741)"
        d="M428.13 831.37c.24-.76.45-1.52.66-2.29A72.88 72.88 0 00339 740a69.46 69.46 0 00-8.51 2.94 72.9 72.9 0 00-41.78 88.4h139.42z"
        transform="translate(-137.41 -64.95)"
      ></path>
      <circle
        cx="710.43"
        cy="603.27"
        r="13.36"
        fill="url(#421cecf6-ea42-4f8e-95af-7dadfc0b5864)"
        opacity="0.7"
      ></circle>
      <circle
        cx="710.43"
        cy="603.27"
        r="12.38"
        fill="url(#b76e450b-11c8-416c-a0eb-ba73061d2446)"
      ></circle>
      <circle
        cx="771.61"
        cy="732.18"
        r="14.57"
        fill="url(#72df51fc-e37e-4ea5-a672-fa692e8e4323)"
        opacity="0.7"
      ></circle>
      <circle
        cx="771.61"
        cy="732.18"
        r="13.84"
        fill="url(#7c061988-e8ee-45a9-b1b1-05af47469914)"
      ></circle>
      <circle
        cx="148.17"
        cy="649.15"
        r="16.01"
        fill="url(#a0922416-7296-47ba-816d-5ff33eb958ea)"
        opacity="0.7"
      ></circle>
      <circle
        cx="148.17"
        cy="649.15"
        r="15.29"
        fill="url(#63e85972-a6d1-4957-b932-816027d688a4)"
      ></circle>
      <path
        fill="url(#299d5e2e-be3b-4509-84b8-ec33c3786422)"
        d="M888.73 82.42a44.33 44.33 0 00-13.08-11.58 43.92 43.92 0 10-22 82c.93 0 1.86 0 2.78-.09a43.91 43.91 0 0032.28-70.28z"
        opacity="0.4"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="#0a80ff"
        d="M895.18 108.87a41.51 41.51 0 01-38.88 41.43c-.87.06-1.75.09-2.63.09a41.51 41.51 0 1120.76-77.47 41.9 41.9 0 0112.37 10.95 41.3 41.3 0 018.38 25z"
        opacity="0.2"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="#f55f44"
        d="M843.45 82.54a45.19 45.19 0 00-6.19 3.26 9.8 9.8 0 00-3.31 3 3.9 3.9 0 00-.08 4.23c1 1.38 3 1.6 4.67 1.69a8.86 8.86 0 008.48-2.8l3.57-3.24c1.24-1.12 2.6-2.67 2.06-4.25-.41-1.21-1.77-1.8-3-2a12.59 12.59 0 00-8.93 1.57"
        opacity="0.05"
        transform="translate(-137.41 -64.95)"
      ></path>
      <circle
        cx="691.13"
        cy="60.31"
        r="2.18"
        fill="#f55f44"
        opacity="0.05"
      ></circle>
      <circle
        cx="735.56"
        cy="46.47"
        r="8.01"
        fill="#f55f44"
        opacity="0.05"
      ></circle>
      <path
        fill="#f55f44"
        d="M886.81 83.86a10.93 10.93 0 11-12.37-11 41.9 41.9 0 0112.37 11zM887.61 132.78a41.41 41.41 0 01-31.31 17.52c-.05-.57-.08-1.15-.08-1.73a19.67 19.67 0 0131.39-15.79z"
        opacity="0.05"
        transform="translate(-137.41 -64.95)"
      ></path>
      <circle
        cx="722.81"
        cy="344.72"
        r="5.1"
        fill="#535461"
        opacity="0.25"
      ></circle>
      <circle
        cx="42.81"
        cy="478.72"
        r="5.1"
        fill="#535461"
        opacity="0.25"
      ></circle>
      <circle
        cx="919.81"
        cy="507.72"
        r="5.1"
        fill="#535461"
        opacity="0.25"
      ></circle>
      <circle
        cx="288.73"
        cy="266.06"
        r="5.1"
        fill="#535461"
        opacity="0.25"
      ></circle>
      <circle
        cx="271.98"
        cy="148.8"
        r="5.1"
        fill="#535461"
        opacity="0.25"
      ></circle>
      <circle
        cx="127.77"
        cy="381.13"
        r="5.1"
        fill="#535461"
        opacity="0.25"
      ></circle>
      <path
        fill="#535461"
        d="M849.18 387.12L844.64 387.12 844.64 382.59 842.79 382.59 842.79 387.12 838.25 387.12 838.25 388.98 842.79 388.98 842.79 393.51 844.64 393.51 844.64 388.98 849.18 388.98 849.18 387.12z"
        opacity="0.25"
      ></path>
      <path
        fill="#535461"
        d="M925.18 230.12L920.64 230.12 920.64 225.59 918.79 225.59 918.79 230.12 914.25 230.12 914.25 231.98 918.79 231.98 918.79 236.51 920.64 236.51 920.64 231.98 925.18 231.98 925.18 230.12z"
        opacity="0.25"
      ></path>
      <path
        fill="#535461"
        d="M601.55 142.41L597.01 142.41 597.01 137.87 595.16 137.87 595.16 142.41 590.62 142.41 590.62 144.26 595.16 144.26 595.16 148.8 597.01 148.8 597.01 144.26 601.55 144.26 601.55 142.41z"
        opacity="0.25"
      ></path>
      <path
        fill="#535461"
        d="M799.65 361.63L795.11 361.63 795.11 357.1 793.26 357.1 793.26 361.63 788.73 361.63 788.73 363.49 793.26 363.49 793.26 368.02 795.11 368.02 795.11 363.49 799.65 363.49 799.65 361.63z"
        opacity="0.25"
      ></path>
      <path
        fill="#535461"
        d="M633.59 512.39L629.06 512.39 629.06 507.86 627.21 507.86 627.21 512.39 622.67 512.39 622.67 514.25 627.21 514.25 627.21 518.78 629.06 518.78 629.06 514.25 633.59 514.25 633.59 512.39z"
        opacity="0.25"
      ></path>
      <path
        fill="#535461"
        d="M168.93 201.4L164.39 201.4 164.39 196.87 162.54 196.87 162.54 201.4 158 201.4 158 203.25 162.54 203.25 162.54 207.79 164.39 207.79 164.39 203.25 168.93 203.25 168.93 201.4z"
        opacity="0.25"
      ></path>
      <path
        fill="#535461"
        d="M10.93 260.4L6.39 260.4 6.39 255.87 4.54 255.87 4.54 260.4 0 260.4 0 262.25 4.54 262.25 4.54 266.79 6.39 266.79 6.39 262.25 10.93 262.25 10.93 260.4z"
        opacity="0.25"
      ></path>
      <path
        fill="#535461"
        d="M231.56 446.12L227.02 446.12 227.02 441.58 225.17 441.58 225.17 446.12 220.64 446.12 220.64 447.97 225.17 447.97 225.17 452.51 227.02 452.51 227.02 447.97 231.56 447.97 231.56 446.12z"
        opacity="0.25"
      ></path>
      <circle
        cx="771.61"
        cy="732.18"
        r="13.84"
        fill="url(#f866518d-8775-4843-b285-e9e24a2ef8da)"
      ></circle>
      <path
        fill="url(#20e3e192-3217-42d5-9266-898a1edf98f2)"
        d="M406.37 413.27a21.11 21.11 0 00-6.23-5.52 20.92 20.92 0 10-10.46 39H391a20.92 20.92 0 0015.37-33.47z"
        opacity="0.4"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="#0a80ff"
        d="M409.44 425.87a19.77 19.77 0 01-18.52 19.73h-1.25a19.77 19.77 0 119.89-36.9 20 20 0 015.89 5.21 19.67 19.67 0 013.99 11.96z"
        opacity="0.2"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path
        fill="#f55f44"
        d="M384.8 413.33a21.52 21.52 0 00-3 1.55 4.67 4.67 0 00-1.58 1.41 1.86 1.86 0 000 2 2.83 2.83 0 002.22.8 4.22 4.22 0 004-1.33l1.7-1.54c.59-.54 1.24-1.27 1-2a1.79 1.79 0 00-1.44-1 6 6 0 00-4.25.75"
        opacity="0.1"
        transform="translate(-137.41 -64.95)"
      ></path>
      <circle
        cx="240.29"
        cy="368.72"
        r="1.04"
        fill="#f55f44"
        opacity="0.1"
      ></circle>
      <circle
        cx="261.45"
        cy="362.13"
        r="3.82"
        fill="#f55f44"
        opacity="0.1"
      ></circle>
      <path
        fill="#f55f44"
        d="M405.45 414a5.2 5.2 0 11-5.89-5.22 20 20 0 015.89 5.22zM405.84 437.26a19.72 19.72 0 01-14.91 8.35v-.83a9.37 9.37 0 0115-7.52z"
        opacity="0.1"
        transform="translate(-137.41 -64.95)"
      ></path>
      <path d="M390.59 202.05H493.59V206.05H390.59z" opacity="0.1"></path>
    </svg>
  );
}

export default NoProjects;
